import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

export type EnergyCardTheme = 'blue' | 'green';

@Component({
  selector: 'lib-energy-summary-card',
  standalone: true,
  templateUrl: './energy-summary-card.component.html',
  styleUrl: './energy-summary-card.component.scss',
  imports: [DecimalPipe, CommonModule],
})
export class EnergySummaryCardComponent {
  @Input() title = '';
  @Input() scope = '';
  @Input() energyValue: string | number = 0;
  @Input() energyUnit = 'kWh';
  @Input() carbonValue: string | number = 0;
  @Input() carbonUnit = 'tCO₂e';
  @Input() comparison = '';
  @Input() comparisonLabel = '';
  @Input() theme: EnergyCardTheme = 'blue';

  @Input() comparisonValue = 0;
}
